<template>
    <!-- Page Content Wrapper -->
    <div id="page-content-wrapper" class="admin-content-area">
        <div class="container-fluid xyz">
            <div class="page-header-top-container">
                <div class="page-name">Modals</div>
            </div>
            <!--page content-->
            <div class="admin-page-content">

                <!--Large Modal-->
                <div class="large-modal">
                    <b-btn v-b-modal.modallg variant="primary">Large modal</b-btn>


                    <!--Large Modal Popup-->
                    <b-modal id="modallg" size="lg" title="Large Modal">
                        We use cookies to improve your website experience

                        <b-button>Learn More</b-button>
                        <b-button>OK, Thanks</b-button>
                    </b-modal>
                    <!--Large Modal Popup-->
                </div>
                <!-- Large Modal -->


            </div>
            <!--page content-->
        </div>
        <app-backend-footer></app-backend-footer>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import BackendFooter from '@/components/backend/partials/footer';
    import { Modal } from 'bootstrap-vue/es/components';
    export default {
        name: 'Center',
        components: {

            'app-backend-footer': BackendFooter,
        },
        data() {
            return {

            }

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {

        }
    }
</script>


// WEBPACK FOOTER //
// src/components/modals.vue